import axios from 'axios';
import { API_BASE_URL as BASE } from './apiConfig';

const client = axios.create({ baseURL: `${BASE}/api` });

client.interceptors.request.use((config) => {
  const isPublicNoticeApi = typeof config.url === 'string' && config.url.startsWith('/notices');
  if (!isPublicNoticeApi) {
    const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
    if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use((res) => {
  if (res.data && typeof res.data === 'object' && 'success' in res.data && 'data' in res.data) {
    res.data = res.data.data;
  }
  return res;
});

// ── 타입 ─────────────────────────────────────────────────────

export interface NoticeListItem {
  id: number;
  title: string;
  isPinned: boolean;
  isBanner: boolean;
  viewCount: number;
  createdAt: string;
}

export interface NoticeListResponse {
  content: NoticeListItem[];
  totalElements: number;
  totalPages: number;
  number: number;
}

export interface NoticeDetail {
  id: number;
  title: string;
  content: string;
  isPinned: boolean;
  isBanner: boolean;
  viewCount: number;
  adminName: string;
  createdAt: string;
  updatedAt: string;
  prevNotice: { id: number; title: string } | null;
  nextNotice: { id: number; title: string } | null;
}

export interface BannerNotice {
  id: number;
  title: string;
  content: string;
  createdAt: string;
}

// 관리자용
export interface AdminNoticeListItem extends NoticeListItem {
  isPublished: boolean;
}

export interface AdminNoticeListResponse {
  content: AdminNoticeListItem[];
  totalElements: number;
  totalPages: number;
  number: number;
}

export interface NoticeFormData {
  title: string;
  content: string;
  isPinned: boolean;
  isBanner: boolean;
  isPublished?: boolean;
}

// ── 사용자/공개 API ──────────────────────────────────────────

export const noticeApi = {
  getList: (params: { page: number; size: number }) =>
    client.get<NoticeListResponse>('/notices', { params }),

  getDetail: (id: number) =>
    client.get<NoticeDetail>(`/notices/${id}`),

  getBanner: () =>
    client.get<BannerNotice[]>('/notices/banner'),
};

// ── 관리자 API ───────────────────────────────────────────────

export const adminNoticeApi = {
  getList: (page: number, size: number) =>
    client.get<AdminNoticeListResponse>('/admin/notices', { params: { page, size } }),

  getDetail: (id: number) =>
    client.get<NoticeDetail>(`/admin/notices/${id}`),

  create: (data: NoticeFormData) =>
    client.post<{ id: number }>('/admin/notices', data),

  update: (id: number, data: NoticeFormData) =>
    client.put(`/admin/notices/${id}`, data),

  delete: (id: number) =>
    client.delete(`/admin/notices/${id}`),

  togglePin: (id: number) =>
    client.patch(`/admin/notices/${id}/pin`),

  toggleBanner: (id: number) =>
    client.patch(`/admin/notices/${id}/banner`),
};
